const initialData = [
  { author: 'Abass Olanrewaju', title: 'JS for Dummies', pages: 500 },
  { author: 'Lanr3waju', title: 'Photography 101', pages: 250 },
  { author: 'Abdul Wasi', title: 'HTML for beginners', pages: 100 },
];

export default initialData;
